import { Component, OnInit, ViewChild } from '@angular/core';
import { MailChimpSync } from './shared/mailchimp-sync.model';
import { SyncModeEnum } from './shared/sync-mode.enum';
import { MailChimpSyncService } from './shared/mailchimp-sync.service';
import { ProfileSearchModalComponent } from '../../profiles/search/profile-search-modal.component';
import { DatagridService, NotificationService, TranslationService } from '../../shared/index';
import { ProfileMin } from '../../profiles/shared/profile-min.model';
import { ConfirmationService } from 'primeng/api';
import { MailchimpList } from './shared/mailchimp-list.model';

@Component({
  selector: 'wl-mailchimp-sync',
  templateUrl: 'mailchimp-sync.component.html',
  styleUrls: ['mailchimp-sync.component.css'],
    standalone: false
})
export class MailChimpSyncComponent implements OnInit {
  public loading: boolean = false;
  public loadError: string = '';
  public syncModel: MailChimpSync;
  public syncModeOptions: any = SyncModeEnum;
  public mailChimpLists: MailchimpList[];
  public profiles: ProfileMin[];

  @ViewChild('profileSearch', { static: false }) private _profileSearch: ProfileSearchModalComponent;

  //Private Services
  private _mailChimpSyncService: MailChimpSyncService;
  private _datagridService: DatagridService;
  private _notificationService: NotificationService;
  private _translationService: TranslationService;
  private _confirmationService: ConfirmationService;

  public constructor(
    mailChimpSyncService: MailChimpSyncService,
    datagridService: DatagridService,
    notificationService: NotificationService,
    translationService: TranslationService,
    confirmationService: ConfirmationService
  ) {
    this.syncModel = new MailChimpSync();
    this._mailChimpSyncService = mailChimpSyncService;
    this._datagridService = datagridService;
    this._notificationService = notificationService;
    this._translationService = translationService;
    this._confirmationService = confirmationService;
    this.profiles = new Array<ProfileMin>();
  }

  ngOnInit(): void {
    this.syncModel.SyncMode = SyncModeEnum.Full;

    this._mailChimpSyncService.GetMailChimpLists().then((data: MailchimpList[]) => {
      this.mailChimpLists = data;
    });
  }
  public selectProfiles = () => {
    this._profileSearch.showModal();
  };

  public profilesSearched($event: any): void {
    this.profiles = $event;
    this.syncModel.ProfileIds = new Array<number>();

    for (let profile of this.profiles) {
      this.syncModel.ProfileIds.push(profile.ProfileId);
    }
  }

  public syncProfiles = () => {
    if (this.syncModel.SyncMode == this.syncModeOptions.Full) {
      this._mailChimpSyncService.FullSync();
      this._translationService.get('integrations.mailchimp.mailchimp-sync.component.full-sync-success').then((message: string) => {
        this._notificationService.success(message);
      });
    } else {
      let hasError: boolean = false;

      if (this.syncModel.ProfileIds.length == 0) {
        this._translationService.get('integrations.mailchimp.mailchimp-sync.component.select-profiles-error').then((message: string) => {
          this._notificationService.error(message);
        });

        hasError = true;
      }
      if (this.syncModel.ListId == '') {
        this._translationService.get('integrations.mailchimp.mailchimp-sync.component.select-list-error').then((message: string) => {
          this._notificationService.error(message);
        });

        hasError = true;
      }
      if (this.syncModel.ListId == 'new' && this.syncModel.ListName == '') {
        this._translationService.get('integrations.mailchimp.mailchimp-sync.component.list-name-error').then((message: string) => {
          this._notificationService.error(message);
        });

        hasError = true;
      }

      if (hasError == false) {
        if (this.syncModel.ListId != 'new') {
          this.syncModel.ListName = this.mailChimpLists.find(x => x.ID === this.syncModel.ListId).Name;
        }
        this._mailChimpSyncService.ManualSync(this.syncModel);

        this._mailChimpSyncService.GetMailChimpLists().then((data: MailchimpList[]) => {
          this.mailChimpLists = data;
        });

        this._translationService.get('integrations.mailchimp.mailchimp-sync.component.manual-sync-success').then((message: string) => {
          this._notificationService.success(message);
        });
      }
    }
  };
}
